export const iconFontAwesomeUsersPeoplePerson = (
	<i className="fa-solid fa-person"></i>
);
